export const packingApis = {
  // ShopOrderController./GoodsListByUser 查询商品（FBA新增装箱单)根据客户id
  goods: '/shop/order/GoodsListByUser',
  // ContainerController./addContainerOrder  新增装箱单   员工端userId必传
  submit: '/container/addContainerOrder',
  // ContainerController./obtainReceivingAddressByUser  根据客户获取收货地址
  obtainAddress: '/container/obtainReceivingAddressByUser',
  // ContainerController./sendReceivingAddressByUser   根据客户查询发货地址
  sendAddress: '/container/sendReceivingAddressByUser',
  // CustomerController./findAllCustomer  客户列表(无分页)
  customr: '/customer/findAllCustomer',
  // 上传
  upload: '/api/cmUser/message/uploadFile'
}
